import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { NumberInputWithSelect } from 'shared/components/UI';
import { selectedActions } from 'shared/actions/searchForm';

import currencies from 'shared/constants/json/currency.json';
// import { MoneyIcon } from 'shared/components/Icons';

import * as s from './../UIStyle.css';

const sluggifiedCurrency = currencies.map(item => ({ ...item, id: item.slug }));

const InputPriceWithCurrencies = ({ currency, actions, onChange, ...inputParams }) =>
  <NumberInputWithSelect
    {...inputParams}
    // Icon={MoneyIcon}
    unitsSwitchOptions={sluggifiedCurrency}
    unitsSwitchValue={currency}
    onUnitsChange={e => {
      actions.set.currency(e);
      onChange(inputParams.value);
    }}
    onChange={onChange}
    titleKey="symbol"
  />;

InputPriceWithCurrencies.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  actions: PropTypes.shape().isRequired,
  currency: PropTypes.shape().isRequired,
};

InputPriceWithCurrencies.defaultProps = {
  currency: sluggifiedCurrency[0],
  onChange: () => {},
};

const mapStateToProps = ({ searchForm: { selected: formState } }) => ({
  currency: formState.currency,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    set: bindActionCreators(
      {
        currency: selectedActions.set.currency,
      },
      dispatch,
    ),
  },
});

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(InputPriceWithCurrencies));



// WEBPACK FOOTER //
// ./src/shared/components/UI/InputPriceWithCurrencies/InputPriceWithCurrencies.js